var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-full"},[_c('div',{staticClass:"container"},[_c('datePicker',{on:{"fechaCalendario":function($event){return _vm.closeModal()}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }